const BASE_ASSET_KEY = 'assets';

const assetKeys = {
	assets: [BASE_ASSET_KEY],
	singleAsset: assetId => [BASE_ASSET_KEY, Number(assetId)],
	myAsset: (assetId, playlistId) => [
		BASE_ASSET_KEY,
		Number(assetId),
		'my',
		Number(playlistId),
	],
	myAssetPlaylists: assetId => [
		BASE_ASSET_KEY,
		Number(assetId),
		'my',
		'playlist',
	],
	myAssetStatuses: assetId => [
		BASE_ASSET_KEY,
		Number(assetId),
		'my',
		'statuses',
	],
	userAssets: (userId, search) => [
		BASE_ASSET_KEY,
		'user',
		Number(userId),
		String(search),
	],
};

export default assetKeys;
